// extracted by mini-css-extract-plugin
export default {"root":"role_profile_action_buttons-module___root___af07d6fe","labelAndIcons":"role_profile_action_buttons-module___labelAndIcons___fe1d6524"};